import { supabase } from "../lib/supabase";

const API_BASE = process.env.REACT_APP_API_BASE || "";

async function authHeaders() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) {
    throw new Error("Bitte melde dich an.");
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

export async function fetchAdminRegionalCalendarsOverview() {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/admin/regional-calendars`, { headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Laden fehlgeschlagen (${res.status}).`);
  }
  return data;
}

export async function reviewCalendarSubmission(body) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/api/admin/calendar-submissions/review`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Speichern fehlgeschlagen (${res.status}).`);
  }
  return data;
}
